<template>
<content-layout :title="title" :headImage="headImage" :tabs="tabs" v-model="activeTab" :spin-show='spinShow'>
    <div class="icons" slot="icons">
        <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div slot="slogan"></div>
    <div class="activity-item mgui-container" slot="/apply/expense">
        <div class="filter-row">
            <div style="float:right">
                排序：<Button size="small" @click="filterItem.sort_at=filterItem.sort_at=='desc'?'asc':'desc';fetchApplyData()">时间 <Icon type="md-arrow-up" v-if="filterItem.sort_at=='asc'"></Icon>
                    <Icon type="md-arrow-down" v-else></Icon>
                </Button>&nbsp;&nbsp;
                <!-- <Button size="small">姓名 <Icon type="arrow-up-c" v-if="filterItem.sort_name=='desc'"></Icon><Icon type="arrow-down-c" v-else></Icon></Button> -->
            </div>
            <!-- {{$store.state.userInfo.role !== 5?'类型：':'我的审批：'}}
            <RadioGroup v-model="filterItem.type" type="button" @on-change="page.page=1;fetchApplyCount();fetchApplyData()" size="small">
                <Radio label="expense">报销单</Radio>
            </RadioGroup>-->
            &nbsp;&nbsp;
            <template v-if="$store.state.userInfo.role !== 5">
                审批：
                <RadioGroup v-model="filterItem.state" type="button" @on-change="page.page=1;fetchApplyData()" size="small">
                    <Radio :label="-1">所有</Radio>
                    <Radio :label="0">
                        {{$store.state.userInfo.role==7?'待打款':'待审批'}}<span class="badge" v-if="expressCount.wit>0">{{expressCount.wit}}</span>
                    </Radio>
                    <!-- <Badge :count="this.expressCount.ing">
              <Radio :label="1">进行中</Radio>
            </Badge> -->
                    <Radio :label="4" v-if="$store.state.userInfo.role!=7">未批准</Radio>
                    <Radio :label="3">已完成</Radio>
                </RadioGroup>&nbsp;
                <Input v-model="filterItem.username" size="small" placeholder="姓名" style="width:120px" icon="md-person"></Input>&nbsp;
                <Button type="success" size="small" @click="page.page=1;fetchApplyData()" icon="md-search">筛选</Button>
            </template>
        </div>
        <div v-if="$store.state.userInfo.role==7 || $store.state.userInfo.role==0 || $store.state.userInfo.role==3" style="text-align:right;margin-bottom:10px">
            待打款合计：￥ {{Number(expressCount.salaryCount).toFixed(2)}} 元
        </div>
        <div v-if="results.length>0">
            <div v-for="(item, index) in results" :key="index" :class="{'collapse-active':item.user_id == $store.state.userInfo.id}">
                <div class="expense-pager" style="position: relative">
                    <template v-if="item.type == 'expense'">
                        <span style="position:absolute;bottom:0;right:0;color:#999;padding:10px;">#{{item.id}}#{{item.department}}#{{item.department_id}}</span>
                        <h3 style="width:100%;text-align:center;padding-left:12px;" @click="read(item)">
                            <Poptip placement="bottom" width="100">
                                <span style="border-bottom:1px solid #999">项 目 费 用 报 销 单</span>
                                <div class="api" slot="content">
                                    <Button v-if="(item.user_id == $store.state.userInfo.id&&item.roval_state==4)||$store.state.userInfo.role==0||$store.state.userInfo.role==3||$store.state.userInfo.role==1" type="text" icon="md-create" @click="editApply(item)" style="margin-right:5px">修改</Button>
                                    <Button v-if="item.roval_state==4 && item.user_id == $store.state.userInfo.id" type="error" icon="md-trash" @click="applyDel(item.id)" size="small">删除</Button>
                                </div>
                            </Poptip>
                        </h3>
                        <div style="font-size:13px;color:#666;padding:10px 0 5px;margin-right:10px;margin-top:-40px">
                            <div style="font-size:13px;color:#666;float:right;padding:0 0 6px" v-if="item.express.type=='邮寄/快递'">
                                <strong style="display:inline-block;width:70px;text-align:right">快递名称：</strong><span style="display:inline-block;width:130px;">{{item.express.name||'--'}}</span>
                                <strong style="display:inline-block;width:70px;text-align:right">快递单号：</strong>{{item.express.number||'--'}}<br>
                                <strong style="display:inline-block;width:70px;text-align:right">快递时间：</strong><span style="display:inline-block;width:130px;">{{item.express.time||'--'}}</span>
                                <strong style="display:inline-block;width:70px;text-align:right">状态：</strong>
                                <span>
                                    {{item.express.state||'--'}}&nbsp;&nbsp;
                                </span>
                                <Button type="info" icon="md-paper-plane" size="small" v-if="$store.state.userInfo.id == item.user_id" @click="editExpress(item)">{{item.express?'修改':'填写快递单号'}}</Button>
                            </div>
                            <div style="font-size:13px;color:#666;float:right;padding:0 0 6px" v-else>
                                <p>票据提供方式：</p>
                                <p>
                                    <Tag :color="!item.express.type?'default':'yellow'" type="border">{{item.express.type||'未设置'}}</Tag><Button type="default" icon="md-paper-plane" size="small" v-if="$store.state.userInfo.id == item.user_id && item.roval_state != 3" @click="editExpress(item)">{{item.express?'修改':'填写快递单号'}}</Button>
                                </p>
                            </div>
                            申请人：{{item.username}}<br>创建时间：{{item.updated_at}}
                        </div>
                        <table class="expense-table">
                            <tr>
                                <th>报销人:</th>
                                <td colspan="3">{{item.content.username}}</td>
                                <th>报销日期:</th>
                                <td colspan="3">{{item.content.time | formatDate}}</td>
                            </tr>
                            <tr>
                                <th>部门:</th>
                                <td colspan="3">{{item.department_name}}</td>
                                <th>项目:</th>
                                <td colspan="3">{{item.project_name}}</td>
                            </tr>
                            <tr>
                                <th>房租及中介费用:</th>
                                <td>{{item.content.salary.a||'--'}}</td>
                                <th>住宿费用:</th>
                                <td>{{item.content.salary.b||'--'}}</td>
                                <th>交通费:</th>
                                <td>{{item.content.salary.c||'--'}}</td>
                                <th>通信费:</th>
                                <td>{{item.content.salary.d||'--'}}</td>
                            </tr>
                            <tr>
                                <th>测试费:</th>
                                <td>{{item.content.salary.e||'--'}}</td>
                                <th>车辆租赁费:</th>
                                <td>{{item.content.salary.f||'--'}}</td>
                                <th>车辆使用费:</th>
                                <td>{{item.content.salary.g||'--'}}</td>
                                <th>办公费:</th>
                                <td>{{item.content.salary.h||'--'}}</td>
                            </tr>
                            <tr>
                                <th>生活用品费:</th>
                                <td>{{item.content.salary.i||'--'}}</td>
                                <th>过路过桥费:</th>
                                <td>{{item.content.salary.j||'--'}}</td>
                                <th>设备购置费:</th>
                                <td>{{item.content.salary.k||'--'}}</td>
                                <th>设备租赁费:</th>
                                <td>{{item.content.salary.l||'--'}}</td>
                            </tr>
                            <tr>
                                <th>零星材料费:</th>
                                <td>{{item.content.salary.m||'--'}}</td>
                                <th>团队建设费:</th>
                                <td>{{item.content.salary.n||'--'}}</td>
                                <th>燃油费:</th>
                                <td>{{item.content.salary.o||'--'}}</td>
                                <th>搬运费:</th>
                                <td>{{item.content.salary.p||'--'}}</td>
                            </tr>
                            <tr>
                                <th>其它费用:</th>
                                <td colspan="7">{{item.content.salary.q||'--'}}</td>
                            </tr>
                            <tr>
                                <th>合计报销金额:</th>
                                <td>{{item.content.salary_all}}</td>
                                <th>借款金额:</th>
                                <td>{{item.content.salary_borrow||'--'}}</td>
                                <th>扣除借款后报销金额:</th>
                                <td colspan="3">{{item.content.salary_deduct||'--'}}</td>
                            </tr>
                            <tr>
                                <th>备注</th>
                                <td colspan="7">{{item.content.remarks||'--'}}</td>
                            </tr>
                            <tr>
                                <th>报销明细表</th>
                                <td colspan="3">
                                    <div v-if="item.content.file">
                                        <Icon type="md-eye" size="20" style="color: #3399ff;vertical-align: top;"></Icon>
                                        <a :href="viewOffice(item.content)" target="_black">在线浏览</a>&nbsp;&nbsp;
                                        <Icon type="md-document" size="20" style="color: #3399ff;vertical-align: top;"></Icon>
                                        <a :href="downFile(item.content)" target="_black">下载</a>
                                    </div>
                                    <div v-else>
                                        没有上传
                                    </div>
                                </td>
                                <th>电子发票</th>
                                <td colspan="3">
                                    <div v-if="item.content.zip_file">
                                        <Icon type="md-document" size="20" style="color: #3399ff;vertical-align: top;"></Icon>
                                        <a :href="downZipFile(item.content)" target="_black">下载</a>
                                    </div>
                                    <div v-else>
                                        --
                                    </div>
                                  </td>
                            </tr>
                        </table>
                    </template>
                    
                    <Alert type="warning" show-icon v-if="item.director.message">{{item.director.message}}</Alert>
                    <Row style="font-size:13px;color:#666;padding:5px 0 0;">
                        <Col span="20">
                        主管审批：
                        <Button :type="item.director.status == 1 && item.roval_state == 0 ? 'error' : 'warning'" icon="md-create" v-if="($store.state.userInfo.role==1 || ($store.state.userInfo.role==3 && item.department == $store.state.userInfo.department)) && (!item.director.status || item.roval_state == 0)" size="small" @click="putApply(item.id, 1)">
                            {{item.director.status == 1 && item.roval_state == 0 ? '操作失败请重新审批' : '请您审批'}}
                        </Button>
                        <span v-else-if="item.director.status">
                            <Tag :color="item.director.status==1?'blue':'red'" type="border">
                                <Icon type="md-checkmark" v-if="item.director.status"></Icon>
                                <Icon type="md-close" v-else></Icon>
                                {{item.director.username}} {{item.director.status?'已批准':'未批准'}}
                            </Tag>
                        </span>
                        <span v-else>
                            <Tag>
                                <Icon type="md-time"></Icon> 待审批
                            </Tag>
                        </span>
                            领导审批：
                            <Button type="warning" icon="md-create" v-if="$store.state.userInfo.role==0 && item.director.status==1 && !item.leader.status" size="small" @click="putApply(item.id, 0)">请您审批</Button>
                            <span v-else-if="item.leader.status">
                                <Tag :color="item.leader.status==1?'blue':'red'" type="border">
                                    <Icon type="md-checkmark" v-if="item.leader.status"></Icon>
                                    <Icon type="md-close" v-else></Icon>
                                    {{item.leader.username}} {{item.leader.status?'已批准':'未批准'}}
                                </Tag>
                            </span>
                            <span v-else-if="item.leader.status!==1">
                                <Tag>
                                    <Icon type="md-time"></Icon> 待审批
                                </Tag>
                            </span>
                            
                            财务审批：
                            <span v-if="$store.state.userInfo.role==3 && item.director.status==1 && !item.cfo.status">
                                <Button type="warning" icon="md-create" size="small" @click="putApply(item.id, 3)">请您审批</Button>
                            </span>
                            <span v-else-if="item.cfo.status">
                                <Tag :color="item.cfo.status==1?'blue':'red'" type="border">
                                    <Icon type="md-checkmark" v-if="item.cfo.status"></Icon>
                                    <Icon type="md-close" v-else></Icon>
                                    {{item.cfo.username}} {{item.cfo.status?'已批准':'未批准'}}
                                </Tag>
                            </span>
                            <span v-else-if="item.cfo.status!==1">
                                <Tag>
                                    <Icon type="md-time"></Icon> 待审批
                                </Tag>
                            </span>
                            <Poptip confirm title="您确定已收到票据？" v-if="$store.state.userInfo.role==3 && item.director.status==1 && item.express.state!=='票据已签收'" @on-ok="expressStateChange(item)">
                                <Button type="info" icon="md-mail" size="small">确认收到票据</Button>
                            </Poptip>
                            <Tag color="blue" type="border" v-if="item.express.state=='票据已签收'">
                                <Icon type="md-email"></Icon>
                                {{item.express.state}}
                            </Tag>
                        出纳：
                        <span v-if="$store.state.userInfo.role==7 && item.cfo.status==1 && item.cn.status!=1">
                            <Poptip confirm title="您确定已经打款吗？" @on-ok="putApplyMoney(item.id, '已打款')">
                                <Button type="warning" icon="md-create" size="small">确认打款</Button>
                                &nbsp;
                            </Poptip>
                            <Poptip confirm title="您确定已核销吗？" @on-ok="putApplyMoney(item.id, '已核销')">
                                <Button type="default" icon="checkmark-circled" size="small">核销</Button>
                                &nbsp;
                            </Poptip>
                        </span>
                        <span v-else-if="item.roval_state==3">
                            <Tag color="blue" type="border">
                                <Icon type="social-yen"></Icon>
                                {{item.cn.message}}
                            </Tag>
                        </span>
                        <span v-else>
                            <Tag>
                                <Icon type="md-time"></Icon> 待打款
                            </Tag>
                        </span>
                        </Col>
                    </Row>
                </div>
            </div>
            <div class="pager">
                <Page :current="page.page" :page-size="15" :total="page.total" @on-change="pagerChange"></Page>
            </div>
        </div>
        <loading :visible="results.length<=0" :icon="loadIcon" :text="loadText"></loading>
    </div>
    <div class="activity-item mgui-container" slot="/apply/expense/post">
        <Form ref="formItem" :model="formItem" label-position="top" :rules="ruleData" class="costs-form">
            <Row :gutter="16">
                <Col span="6">
                <FormItem label="报销人" prop="username">
                    <Input v-model="formItem.username" style="max-width:170px"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="报销日期" prop="time">
                    <DatePicker type="date" v-model="formItem.time" placeholder="选择报销日期"></DatePicker>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="上传明细表">
                    <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess" accept=".xls,.xlsx,.pdf" :format="['xls','xlsx','pdf']" :max-size="10048" :data="{file_type:'expense_table'}" :headers="uploadHeaders" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" type="drag" v-show="uploadState==0" :action="uploadApiPath" class="upload-item" style="display:inline-block;margin:0;">
                        <div style="padding: 2px 10px;line-height:25px;" v-if="!formItem.file">
                            <Icon type="ios-cloud-upload" size="22" style="color: #3399ff;vertical-align: top;"></Icon>
                            <span>选择报销明细表</span>
                        </div>
                        <div style="padding: 2px 10px;line-height:25px;" v-else>
                            <Icon type="document" size="22" style="color: #3399ff;vertical-align: top;"></Icon>
                            <span @click="formItem.file=''">已经上传，点击修改</span>
                        </div>
                    </Upload>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="上传电子发票[仅支持zip,rar]">
                    <Upload ref="upload" :show-upload-list="false" :on-success="handleZipSuccess" accept=".rar,.zip,.7z" :format="['zip','rar']" :max-size="10048" :data="{file_type:'invoice_zip'}" :headers="uploadHeaders" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" type="drag" v-show="uploadState==0" :action="uploadApiPath" class="upload-item" style="display:inline-block;margin:0;">
                        <div style="padding: 2px 10px;line-height:25px;" v-if="!formItem.zip_file">
                            <Icon type="ios-cloud-upload" size="22" style="color: #3399ff;vertical-align: top;"></Icon>
                            <span>请选择打包后的电子发票</span>
                        </div>
                        <div style="padding: 2px 10px;line-height:25px;" v-else>
                            <Icon type="document" size="22" style="color: #3399ff;vertical-align: top;"></Icon>
                            <span @click="formItem.zip_file=''">已经上传，点击修改</span>
                        </div>
                    </Upload>
                </FormItem>
                </Col>
                <Col span="16">
                <FormItem label="项目名称" prop="department" style="display:inline-block">
                    <span v-if="formItem.department">{{formItem.department}}-{{formItem.project}}</span>
                    <!-- <Input v-model="formItem.department" :disabled="true" :readonly="true" style="max-width:170px;background:#fff"></Input> -->
                    <Cascader style="display:inline-block" @on-change="handleChange" placeholder="选择项目组" :data="$store.state.department" change-on-select>
                        <a href="javascript:void(0)" style="margin-left:15px">
                            <Icon type="ios-checkmark-circle" /> 请选择
                        </a>
                    </Cascader>
                </FormItem>
                <!-- <FormItem label="项目名称" style="display:inline-block;width:220px">
                  <Input v-model="formItem.project" :disabled="true" style="max-width:170px;background:#fff"></Input>{{formItem.project_id}}
                </FormItem> -->
                </Col>
            </Row>
            <Divider>报销内容</Divider>
            <Row :gutter="16">
                <Col span="4">
                <FormItem label="房租及中介费用费用">
                    <Input v-model="formItem.salary.a" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="住宿费用">
                    <Input v-model="formItem.salary.b" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="交通费">
                    <Input v-model="formItem.salary.c" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="通信费">
                    <Input v-model="formItem.salary.d" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="测试费">
                    <Input v-model="formItem.salary.e" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="车辆租赁费">
                    <Input v-model="formItem.salary.f" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="车辆使用费">
                    <Input v-model="formItem.salary.g" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="办公费">
                    <Input v-model="formItem.salary.h" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="生活用品费">
                    <Input v-model="formItem.salary.i" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="过路过桥费">
                    <Input v-model="formItem.salary.j" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="设备购置费">
                    <Input v-model="formItem.salary.k" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="设备租赁费">
                    <Input v-model="formItem.salary.l" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="零星材料费">
                    <Input v-model="formItem.salary.m" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="团队建设费">
                    <Input v-model="formItem.salary.n" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="燃油费">
                    <Input v-model="formItem.salary.o" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="搬运费">
                    <Input v-model="formItem.salary.p" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="其它费用">
                    <Input v-model="formItem.salary.q" @on-blur="salaryChange" number placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem label="合计报销金额">
                    <Input v-model="formItem.salary_all" disabled placeholder="自动统计"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="借款金额">
                    <Input v-model="formItem.salary_borrow" placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="扣除借款后报销金额">
                    <Input v-model="formItem.salary_deduct" placeholder="请输入"></Input>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem label="备注">
                    <Input type="textarea" v-model="formItem.remarks" placeholder="备注"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row>
                <FormItem>
                    <Button type="primary" @click="submitApply('formItem')" :disabled="isDisabled">
                        {{formItem.user_id==0?'提交申请':'修改申请'}}
                    </Button>
                    <Tag color="red" v-show="errorInfo">{{errorInfo}}</Tag>
                </FormItem>
            </Row>
        </Form>
        <Modal title="填写快递单" v-model="expressModal" width="300" @on-ok="expressSubmit" :loading="expressModalLoading">
            <Form ref="express" :model="express" label-position="top" style="padding-left:10px">
                <FormItem label="票据提供方式:" prop="name">
                    <Select v-model="express.type" style="max-width:230px">
                        <Option label="线下提交" value="线下提交"></Option>
                        <Option label="邮寄/快递" value="邮寄/快递"></Option>
                    </Select>
                </FormItem>
                <FormItem label="快递名称:" v-if="express.type=='邮寄/快递'">
                    <Select v-model="express.name" style="max-width:230px">
                        <Option :label="exp" :value="exp" v-for="(exp, ind) in exps" :key="ind"></Option>
                    </Select>
                </FormItem>
                <FormItem label="快递单号:" v-if="express.type=='邮寄/快递'">
                    <Input v-model="express.number" style="max-width:230px"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
    <!-- 报销汇总 -->
    <div class="activity-item mgui-container" slot="/apply/expense/count" style="padding-bottom:100px">
        <expense-count></expense-count>
    </div>
</content-layout>
</template>

<script>
import {
    formatTime
} from '../util/filter'
import {
    fetch,
    put,
    post,
    del
} from '../fetch/api'

// const modelName = 'user'
const exps = ['韵达快递', '天天快递', '佳吉快递', '百世物流', '联邦快递', '德邦物流', '华强物流', '中铁物流', '百世汇通', '中铁快运', 'E速宝', '信丰物流', '顺丰速运', '申通快递', '龙邦速递', '天地华宇', '快捷快递', '邮政国内小包', '黑猫宅急便', '新邦物流', '卡行天下', '安能物流', '贝海国际速递', '佳吉快运', '能达速递', '优速快递 ', '增益速递', '国通快递', '邮政小包', '圆通速递', '中通快递', 'EMS经济快递', 'EMS', '德邦快递', '凡宇速递', '联昊通', '全峰快递', '全一快递', '城市100', '广东EMS', '速尔', '燕文上海', '燕文深圳', '燕文义乌', '飞远(爱彼西)配送', '宅急送']

let formItem = {
    id: 0,
    user_id: 0,
    type: 'expense',
    username: '',
    mobile: '',
    time: '',
    department: '',
    project: '',
    salary: {},
    salary_all: '',
    salary_borrow: '',
    salary_deduct: '',
    file: '',
    zip_file: ''
}

export default {
    name: 'Apply',
    components: {
        ContentLayout: resolve => {
            require(['../components/ContentLayoutComponent'], resolve)
        },
        Loading: resolve => {
            require(['../components/LoadingComponent'], resolve)
        },
        // ApplyLoan: resolve => {
        //     require(['../components/ApplyLoanComponent'], resolve)
        // },
        // ApplyMoney: resolve => {
        //     require(['../components/ApplyMoneyComponent'], resolve)
        // },
        ExpenseCount: resolve => {
            require(['../components/ApplyExpenseCount'], resolve)
        },
        // UserEditForm: resolve => { require(['../components/UserEditFormComponent'], resolve) }
    },
    data() {
        let token = localStorage.getItem('token')

        return {
            title: '报销',
            tabs: [{
                    'title': '审批',
                    'key': '/apply/expense',
                    'visible': true
                },
                {
                    'title': '报销单',
                    'key': '/apply/expense/post',
                    'visible': true
                }
                // {
                //     'title': '借款申请',
                //     'key': '/apply/expense/loan',
                //     'visible': true
                // },
                // {
                //     'title': '用款申请',
                //     'key': '/apply/expense/money',
                //     'visible': true
                // },
                // {
                //     'title': '报销汇总',
                //     'key': '/apply/expense/count',
                //     'visible': this.$store.state.userInfo.role === 0
                // }
            ],
            activeTab: '/apply/expense',
            headImage: '/static/images/bg/money.jpeg',
            spinShow: true,
            isDisabled: false,
            exportTime: [],
            token: token,
            filterItem: {
                sort_at: 'desc',
                sort_name: 'desc',
                type: 'expense',
                state: 0,
                // status: 1,
                // department_id: [],
                time: []
            },
            reasons: ['家庭原因', '个人原因', '发展原因', '合同到期不续签', '协议解除', '无法胜任工作', '经济性裁员', '严重违法违纪', '其他'],
            formItem: JSON.parse(JSON.stringify(formItem)),
            currentId: 0,
            exps: exps,
            express: {
                type: '邮寄/快递',
                name: '',
                number: '',
                state: ''
            },
            errorInfo: '',
            expressCount: {},
            expressModalLoading: true,
            loadText: '正在加载...',
            loadIcon: 'refresh',
            expressRuleData: {
                name: [{
                    required: true,
                    message: '请选择快递名称',
                    trigger: 'change'
                }],
                number: [{
                    required: true,
                    message: '请输入快递单号',
                    trigger: 'change'
                }]
            },
            ruleData: {
                time: [{
                    required: true,
                    type: 'date',
                    message: '请选择报销时间',
                    trigger: 'change'
                }],
                username: [{
                    required: true,
                    message: '请输入报销人姓名',
                    trigger: 'change'
                }],
                department: [{
                    required: true,
                    message: '请选择报销部门',
                    trigger: 'change'
                }],
                project: [{
                    required: true,
                    message: '请选择项目名称',
                    trigger: 'change'
                }],
                salary_all: [{
                    required: true,
                    message: '请输入合计报销金额',
                    trigger: 'change'
                }]
            },
            expressModal: false,
            leader: [],
            leaderIds: [51, 52],
            leaveCollapse: null,
            results: [],
            page: {
                total: 0,
                page: 1
            },
            uploadList: [],
            uploadState: 0,
            uploadResult: {},
            uploadApiPath: '/api/users/upload/attend',
            uploadHeaders: {
                'Authorization': `Bearer ${token}`
            },
            officeOnline: false,
            officePath: ''
        }
    },
    watch: {
        $route(to) {
            this.routeChange(to)
        }
    },
    mounted() {
        let action = this.$route.params.action
        if (action) this.leaveCollapse = action + '_' + 0
        formItem.username = this.$store.state.userInfo.username
        formItem.mobile = this.$store.state.userInfo.mobile
        // this.filterItem.state = this.$store.state.userInfo.role === 7 ? 2 : 0
        this.fetchApplyData()
        this.fetchApplyCount()
        this.routeChange(this.$route)
    },
    filters: {
        substr(str) {
            return str.substr(0, 10)
        },
        formatDate(date) {
            date = new Date(date)
            return formatTime(date, 'yyyy-MM-dd')
        },
        formatTime(time) {
            if (!time) return '--'
            let date = new Date(time * 1000)
            return formatTime(date, 'yyyy-MM-dd hh:mm')
        }
    },
    methods: {
        salaryChange() {
            let total = 0
            for (let k in this.formItem.salary) {
                if (typeof this.formItem.salary[k] === 'number') total = total + Number(this.formItem.salary[k])
            }
            this.formItem.salary_all = total.toFixed(2)
        },
        handleChange(val, selectedData) {
            this.$set(this.formItem, 'department', '')
            this.$set(this.formItem, 'project', '')
            this.$set(this.formItem, 'department_id', '')
            this.$set(this.formItem, 'project_id', '')
            this.$set(this.formItem, 'department', selectedData[0].label)
            this.$set(this.formItem, 'department_id', selectedData[0].value)
            if (selectedData[1]) {
                this.$set(this.formItem, 'project', selectedData[1].label)
                this.$set(this.formItem, 'project_id', selectedData[1].value)
            }
        },
        putApply(id, role) {
            let title = ['领导', '主管审批', '项目经理', '财务']

            this.$Modal.confirm({
                title: title[role],
                render: (h) => {
                    return [
                        h('Select', {
                            style: 'paddingTop:20px',
                            props: {
                                value: null,
                                autofocus: true,
                                placeholder: '请选择'
                            },
                            on: {
                                input: (val) => {
                                    this.agree = val
                                }
                            }
                        }, [
                            h('Option', {
                                props: {
                                    value: 1
                                }
                            }, '批准'),
                            h('Option', {
                                props: {
                                    value: 0
                                }
                            }, '不批准')
                        ]),
                        h('Input', {
                            style: 'paddingTop:20px',
                            props: {
                                type: 'textarea',
                                value: this.value,
                                autofocus: true,
                                placeholder: '输入原因'
                            },
                            on: {
                                input: (val) => {
                                    this.value = val
                                }
                            }
                        })
                    ]
                },
                onOk: () => {
                    if (this.agree === '' || this.agree === undefined) {
                        this.$Message.error('请选择审核状态')
                        return false
                    }

                    put(`console/applyAgree/${id}`, {
                        'agree': this.agree,
                        'message': this.value || ''
                    }).then(res => {
                        this.$Message.info(res.msg)
                        this.fetchApplyData()
                        this.fetchApplyCount()
                    })
                }
            })
        },
        putApplyMoney(id, msg) {
            put(`console/applyAgree/${id}`, {
                'agree': 1,
                'role': 7,
                'message': msg
            }).then(res => {
                this.$Message.info(res.msg)
                this.fetchApplyData()
                this.fetchApplyCount()
            })
        },
        fetchDepartment() {
            this.$store.dispatch('setDepartment', false)
        },
        expressStateChange(item) {
            item.express.state = '票据已签收'
            put(`console/applyExpressUpdate/${item.id}`, {
                'express': JSON.stringify(item.express)
            }).then(res => {
                this.$Message.info(res.msg)
            })
        },
        applyDel(id) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '确定要删除该申请吗？',
                onOk: () => {
                    del(`console/apply/${id}`).then(res => {
                        this.$Message.info(res.msg)
                        this.fetchApplyData()
                    })
                }
            })
        },
        editExpress(item) {
            this.expressModal = true
            this.currentId = item.id
            this.express = item.express
        },
        expressSubmit() {
            this.$refs['express'].validate((valid) => {
                if (valid) {
                    if (this.express.type === '线下提交') {
                        this.express.name = ''
                        this.express.number = ''
                    }
                    post(`console/applyExpress`, {
                        'id': this.currentId,
                        'express': this.express
                    }).then(res => {
                        if (res.status === 'ok') {
                            this.$Message.info('快递添加成功')
                            this.expressModal = false
                        } else {
                            this.$Message.error('快递添加错误')
                            setTimeout(() => {
                                this.expressModalLoading = false
                                this.$nextTick(() => {
                                    this.expressModalLoading = true
                                })
                            }, 2000)
                        }
                    })
                } else {
                    setTimeout(() => {
                        this.expressModalLoading = false
                        this.$nextTick(() => {
                            this.expressModalLoading = true
                        })
                    }, 2000)
                }
            })
        },
        editApply(item) {
            // console.log(item)
            this.activeTab = '/apply/expense/post'
            let data = JSON.parse(JSON.stringify(item.content))
            data['time'] = formatTime(new Date(data.time), 'yyyy-MM-dd')
            data['id'] = item.id
            // data['status'] = data['agree']
            this.formItem = data
        },
        submitApply(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (!this.formItem.file) {
                        this.$Message.error('请上传报销明细表')
                        this.errorInfo = '请上传报销明细表'
                        setTimeout(() => {
                            this.errorInfo = ''
                        }, 2000)
                        return false
                    }
                    this.isDisabled = true
                    let data = {
                        id: this.formItem.id,
                        user_id: this.formItem.user_id,
                        type: 'expense',
                        department_id: this.formItem.department_id,
                        project_id: this.formItem.project_id,
                        content: JSON.stringify({
                            time: this.formItem.time,
                            username: this.formItem.username,
                            mobile: this.formItem.mobile,
                            department: this.formItem.department,
                            project: this.formItem.project,
                            salary: this.formItem.salary,
                            salary_all: this.formItem.salary_all,
                            salary_borrow: this.formItem.salary_borrow,
                            salary_deduct: this.formItem.salary_deduct,
                            remarks: this.formItem.remarks,
                            file: this.formItem.file,
                            zip_file: this.formItem.zip_file
                        })
                    }
                    post('console/apply', data).then(res => {
                        if (res.status === 'ok') {
                            this.$router.push({
                                'path': '/apply/expense'
                            })
                            this.fetchApplyData()
                            this.activeTab = '/apply/expense'
                        }
                        this.$Message.info(res.msg)
                    })
                    setTimeout(() => {
                        this.isDisabled = false
                    }, 2000)
                }
            })
        },
        fetchApplyCount() {
            let params = this.filterItem
            params.page = this.page.page
            fetch(`console/applyCount/${this.filterItem.type}`, {
                params: params
            }).then(res => {
                if (res.status === 'ok') this.expressCount = res.count
            })
        },
        pagerChange(val) {
            this.page.page = val
            this.fetchApplyData()
        },
        fetchApplyData() {
            let params = this.filterItem
            params.page = this.page.page
            this.page.total = 0
            this.results = []
            this.loadText = '正在加载...'
            this.loadIcon = 'refresh'
            this.spinShow = true
            fetch(`console/apply/${params.type}`, {
                params: params
            }).then(res => {
                if (res.status === 'ok' && res.result.data.length > 0) {
                    this.page.total = res.result.total
                    this.results = res.result.data
                    for (let k in this.results) {
                        this.results[k].content = JSON.parse(this.results[k].content)
                        // 填充表单
                        // if (this.results[k].user_id === this.$store.state.userInfo.id && this.results[k].agree === null) {
                        //   let res = JSON.parse(JSON.stringify(this.results[k]))
                        //   this.formItem = {
                        //     id: res.id,
                        //     user_id: res.user_id,
                        //     agree: res.agree,
                        //     type: 'expense',
                        //     time: res.content.time,
                        //     username: res.content.username,
                        //     mobile: res.content.mobile,
                        //     department: res.content.department,
                        //     project: res.content.project,
                        //     salary: res.content.salary,
                        //     salary_all: res.content.salary_all,
                        //     salary_borrow: res.content.salary_borrow,
                        //     salary_deduct: res.content.salary_deduct,
                        //     remarks: res.content.remarks,
                        //     file: res.content.file
                        //   }
                        // }
                    }
                } else {
                    this.loadIcon = 'alert-circled'
                    this.loadText = '暂无记录'
                }
                this.spinShow = false
            }).catch(() => {
                this.loadIcon = 'alert-circled'
                this.loadText = '加载失败，请重试！'
                this.spinShow = false
            })
        },
        routeChange(route) {
            let action = route.params.action
            if (action === undefined) {
                this.activeTab = '/apply/expense'
                // this.fetchData()
                this.spinShow = false
            }
            if (action === 'post') {
                this.fetchDepartment()
                this.formItem = JSON.parse(JSON.stringify(formItem))
                this.activeTab = '/apply/expense/post'
                this.spinShow = false
            }
            if (action === 'count') {
                this.fetchDepartment()
                this.activeTab = '/apply/expense/count'
                this.spinShow = false
            }
        },
        formatPath(path) {
            return `${this.apiPath}api/console/pdf?type=downpdf&path=${path}&name=浙江宇脉-离职手续单&token=${this.token}`
        },
        read(item) {
            if (item.status === 0) {
                item.status = 1
                put(`console/applyStatus/${item.id}?status=${item.status}`)
            }
        },
        uploadCancel() {
            this.uploadState = 0
        },
        uploadOk() {
            if (this.attendMonth === '' || this.attendMonth === null) {
                this.$Message.error('请选择日期')
            } else {
                this.uploadState = 3
                let path = this.uploadResult.file_path
                post('users/attend/table', {
                    'file_path': path,
                    'date': this.attendMonth
                }).then(res => {
                    if (res.status === 'ok') {
                        this.$Message.success('更新成功')
                        this.uploadState = 0
                        this.attendMonth = ''
                        this.uploadModal = false
                        this.fetchDataUsers()
                    }
                })
            }
        },
        handleSuccess(res) {
            if (res.status === 'ok') {
                this.formItem.file = res.result
                // this.attendMonth = res.time
            }
        },
        handleZipSuccess(res) {
            if (res.status === 'ok') {
                this.formItem.zip_file = res.result
                // this.attendMonth = res.time
            }
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: '上传错误',
                desc: '您上传的文件可能有误【' + file.name + '】, 请选择xls/xlsx文件.'
            })
        },
        handleMaxSize(file) {
            this.$Notice.warning({
                title: '文件太大',
                desc: '文件  ' + file.name + ' 太大了, 请不要超过 2M.'
            })
        },
        handleBeforeUpload() {
            const check = this.uploadList.length < 5
            if (!check) {
                this.$Notice.warning({
                    title: 'Up to five pictures can be uploaded.'
                })
            }
            return check
        },
        getDom (ver) {
            ver = ver || 'v1'
            let dom = this.apiPath
            if (ver === 'v2') dom = dom.replace('api', 'v2')
            return dom
        },
        downFile(con) {
            const path = con.file.file_path
            const dom = this.getDom(con.ver)
            return `${dom}../${path}`
        },
        downZipFile(con) {
            const path = con.zip_file.file_path
            const dom = this.getDom(con.ver)
            return `${dom}../${path}`
        },
        viewOffice(con) {
            const path = con.file.file_path
            const dom = this.getDom(con.ver)
            return 'https://view.officeapps.live.com/op/view.aspx?src=' + dom + path
        }
    }
}
</script>

<style>
.expense-pager {
    /*border: 1px solid #78a9b1;*/
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .3)
}

.expense-table {
    width: 100%;
    border-collapse: collapse;
}

.expense-table th {
    width: 160px;
    text-align: right;
    background: #f7f7f7;
    font-size: 12px;
}

.expense-table td {
    width: 100px;
}

.expense-table th,
.expense-table td {
    border: 1px solid #78a9b1;
    padding: 5px 5px;
}

.users-count {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 4px;
    /*background: #f7f7f7;*/
    color: #fff;
    padding: 5px 10px;
}

.filter-row-item {
    display: inline-block;
}

.users-count span,
.users-count a {
    margin-right: 10px
}

.leader-select {
    border: 1px solid #ccc;
    background: #f7f7f7;
}

.users-count a {
    color: #fff;
    text-decoration: underline
}

.collapse-active .ivu-collapse-content {
    display: block !important
}

.collapse-active .ivu-collapse-header {
    background: #ffeccf
}

@media (max-width: 640px) {
    .filter-row-item {
        display: block;
        margin-bottom: 10px
    }

    .users-count {
        width: 200px;
    }
}
</style>
